import { FiTier, type PlaidInstitutionResult } from './bank-compatibility.types'

/**
 * Static FI tier classification map.
 * Built from:
 * - healthyFinancialInstitutionIds (API) → WELL_SUPPORTED
 * - errorProneInstitutionIds (API) → LIMITED_SUPPORT (overrides healthy)
 * - LimitedBankAccessStatus unsupported/unknown (API) → LIMITED_SUPPORT
 *
 * Default for Plaid-supported institutions not in this map: LIMITED_SUPPORT
 * Institutions not returned by Plaid Search: NOT_SUPPORTED (classified at search time)
 *
 * See CORE-6147 for planned quarterly refresh of this list.
 */
export const FI_TIER_MAP: Record<string, FiTier> = {
  ins_1: FiTier.WELL_SUPPORTED,
  ins_10: FiTier.WELL_SUPPORTED,
  ins_100635: FiTier.WELL_SUPPORTED,
  ins_100742: FiTier.WELL_SUPPORTED,
  ins_100864: FiTier.WELL_SUPPORTED,
  ins_100870: FiTier.WELL_SUPPORTED,
  ins_101551: FiTier.WELL_SUPPORTED,
  ins_101559: FiTier.WELL_SUPPORTED,
  ins_101560: FiTier.WELL_SUPPORTED,
  ins_101561: FiTier.WELL_SUPPORTED,
  ins_102552: FiTier.WELL_SUPPORTED,
  ins_103544: FiTier.WELL_SUPPORTED,
  ins_103548: FiTier.WELL_SUPPORTED,
  ins_105483: FiTier.WELL_SUPPORTED,
  ins_105496: FiTier.WELL_SUPPORTED,
  ins_105499: FiTier.WELL_SUPPORTED,
  ins_105846: FiTier.WELL_SUPPORTED,
  ins_106296: FiTier.WELL_SUPPORTED,
  ins_109532: FiTier.WELL_SUPPORTED,
  ins_109533: FiTier.WELL_SUPPORTED,
  ins_109535: FiTier.WELL_SUPPORTED,
  ins_109564: FiTier.WELL_SUPPORTED,
  ins_109578: FiTier.WELL_SUPPORTED,
  ins_109590: FiTier.WELL_SUPPORTED,
  ins_109643: FiTier.WELL_SUPPORTED,
  ins_109675: FiTier.WELL_SUPPORTED,
  ins_109682: FiTier.WELL_SUPPORTED,
  ins_109691: FiTier.WELL_SUPPORTED,
  ins_109701: FiTier.WELL_SUPPORTED,
  ins_109707: FiTier.WELL_SUPPORTED,
  ins_109763: FiTier.WELL_SUPPORTED,
  ins_109778: FiTier.WELL_SUPPORTED,
  ins_109781: FiTier.WELL_SUPPORTED,
  ins_109862: FiTier.WELL_SUPPORTED,
  ins_109867: FiTier.WELL_SUPPORTED,
  ins_109911: FiTier.WELL_SUPPORTED,
  ins_109913: FiTier.WELL_SUPPORTED,
  ins_109917: FiTier.WELL_SUPPORTED,
  ins_109930: FiTier.WELL_SUPPORTED,
  ins_109933: FiTier.WELL_SUPPORTED,
  ins_109971: FiTier.WELL_SUPPORTED,
  ins_110004: FiTier.WELL_SUPPORTED,
  ins_110019: FiTier.WELL_SUPPORTED,
  ins_110422: FiTier.WELL_SUPPORTED,
  ins_110427: FiTier.WELL_SUPPORTED,
  ins_110430: FiTier.WELL_SUPPORTED,
  ins_110476: FiTier.WELL_SUPPORTED,
  ins_110482: FiTier.WELL_SUPPORTED,
  ins_110501: FiTier.WELL_SUPPORTED,
  ins_110503: FiTier.WELL_SUPPORTED,
  ins_110549: FiTier.WELL_SUPPORTED,
  ins_110602: FiTier.WELL_SUPPORTED,
  ins_110690: FiTier.WELL_SUPPORTED,
  ins_110728: FiTier.WELL_SUPPORTED,
  ins_110835: FiTier.WELL_SUPPORTED,
  ins_111007: FiTier.WELL_SUPPORTED,
  ins_111013: FiTier.WELL_SUPPORTED,
  ins_111014: FiTier.WELL_SUPPORTED,
  ins_111037: FiTier.WELL_SUPPORTED,
  ins_111302: FiTier.WELL_SUPPORTED,
  ins_111607: FiTier.WELL_SUPPORTED,
  ins_111796: FiTier.WELL_SUPPORTED,
  ins_111902: FiTier.WELL_SUPPORTED,
  ins_113113: FiTier.WELL_SUPPORTED,
  ins_113598: FiTier.WELL_SUPPORTED,
  ins_113779: FiTier.WELL_SUPPORTED,
  ins_113790: FiTier.WELL_SUPPORTED,
  ins_113800: FiTier.WELL_SUPPORTED,
  ins_113801: FiTier.WELL_SUPPORTED,
  ins_113862: FiTier.WELL_SUPPORTED,
  ins_113976: FiTier.WELL_SUPPORTED,
  ins_114034: FiTier.WELL_SUPPORTED,
  ins_114047: FiTier.WELL_SUPPORTED,
  ins_114066: FiTier.WELL_SUPPORTED,
  ins_114149: FiTier.WELL_SUPPORTED,
  ins_114213: FiTier.WELL_SUPPORTED,
  ins_114454: FiTier.WELL_SUPPORTED,
  ins_114506: FiTier.WELL_SUPPORTED,
  ins_114664: FiTier.WELL_SUPPORTED,
  ins_114700: FiTier.WELL_SUPPORTED,
  ins_115291: FiTier.WELL_SUPPORTED,
  ins_115563: FiTier.WELL_SUPPORTED,
  ins_115581: FiTier.WELL_SUPPORTED,
  ins_115585: FiTier.WELL_SUPPORTED,
  ins_115599: FiTier.WELL_SUPPORTED,
  ins_115652: FiTier.WELL_SUPPORTED,
  ins_115686: FiTier.WELL_SUPPORTED,
  ins_116196: FiTier.WELL_SUPPORTED,
  ins_116224: FiTier.WELL_SUPPORTED,
  ins_116243: FiTier.WELL_SUPPORTED,
  ins_116282: FiTier.WELL_SUPPORTED,
  ins_116294: FiTier.WELL_SUPPORTED,
  ins_116314: FiTier.WELL_SUPPORTED,
  ins_116354: FiTier.WELL_SUPPORTED,
  ins_116418: FiTier.WELL_SUPPORTED,
  ins_116497: FiTier.WELL_SUPPORTED,
  ins_116584: FiTier.WELL_SUPPORTED,
  ins_116594: FiTier.WELL_SUPPORTED,
  ins_116619: FiTier.WELL_SUPPORTED,
  ins_116627: FiTier.WELL_SUPPORTED,
  ins_116725: FiTier.WELL_SUPPORTED,
  ins_116754: FiTier.WELL_SUPPORTED,
  ins_116756: FiTier.WELL_SUPPORTED,
  ins_116758: FiTier.WELL_SUPPORTED,
  ins_116760: FiTier.WELL_SUPPORTED,
  ins_116794: FiTier.WELL_SUPPORTED,
  ins_116823: FiTier.WELL_SUPPORTED,
  ins_116954: FiTier.WELL_SUPPORTED,
  ins_117026: FiTier.WELL_SUPPORTED,
  ins_117048: FiTier.WELL_SUPPORTED,
  ins_117127: FiTier.WELL_SUPPORTED,
  ins_117193: FiTier.WELL_SUPPORTED,
  ins_117219: FiTier.WELL_SUPPORTED,
  ins_117228: FiTier.WELL_SUPPORTED,
  ins_117261: FiTier.WELL_SUPPORTED,
  ins_117701: FiTier.WELL_SUPPORTED,
  ins_118119: FiTier.WELL_SUPPORTED,
  ins_119270: FiTier.WELL_SUPPORTED,
  ins_119465: FiTier.WELL_SUPPORTED,
  ins_119491: FiTier.WELL_SUPPORTED,
  ins_119532: FiTier.WELL_SUPPORTED,
  ins_119658: FiTier.WELL_SUPPORTED,
  ins_120000: FiTier.WELL_SUPPORTED,
  ins_120003: FiTier.WELL_SUPPORTED,
  ins_120016: FiTier.WELL_SUPPORTED,
  ins_120020: FiTier.WELL_SUPPORTED,
  ins_120026: FiTier.WELL_SUPPORTED,
  ins_120033: FiTier.WELL_SUPPORTED,
  ins_120036: FiTier.WELL_SUPPORTED,
  ins_120050: FiTier.WELL_SUPPORTED,
  ins_120073: FiTier.WELL_SUPPORTED,
  ins_120078: FiTier.WELL_SUPPORTED,
  ins_120218: FiTier.WELL_SUPPORTED,
  ins_120227: FiTier.WELL_SUPPORTED,
  ins_120334: FiTier.WELL_SUPPORTED,
  ins_120406: FiTier.WELL_SUPPORTED,
  ins_121816: FiTier.WELL_SUPPORTED,
  ins_122133: FiTier.WELL_SUPPORTED,
  ins_123314: FiTier.WELL_SUPPORTED,
  ins_123432: FiTier.WELL_SUPPORTED,
  ins_124690: FiTier.WELL_SUPPORTED,
  ins_126237: FiTier.WELL_SUPPORTED,
  ins_126321: FiTier.WELL_SUPPORTED,
  ins_126729: FiTier.WELL_SUPPORTED,
  ins_127171: FiTier.WELL_SUPPORTED,
  ins_127291: FiTier.WELL_SUPPORTED,
  ins_127981: FiTier.WELL_SUPPORTED,
  ins_127989: FiTier.WELL_SUPPORTED,
  ins_127990: FiTier.WELL_SUPPORTED,
  ins_127991: FiTier.WELL_SUPPORTED,
  ins_128026: FiTier.LIMITED_SUPPORT, // Capital One — LBA unsupported, no auto-recon data
  ins_128007: FiTier.WELL_SUPPORTED,
  ins_128822: FiTier.WELL_SUPPORTED,
  ins_128828: FiTier.WELL_SUPPORTED,
  ins_129525: FiTier.WELL_SUPPORTED,
  ins_129909: FiTier.WELL_SUPPORTED,
  ins_13: FiTier.WELL_SUPPORTED,
  ins_130973: FiTier.WELL_SUPPORTED,
  ins_131846: FiTier.WELL_SUPPORTED,
  ins_131856: FiTier.WELL_SUPPORTED,
  ins_131862: FiTier.WELL_SUPPORTED,
  ins_132102: FiTier.WELL_SUPPORTED,
  ins_132652: FiTier.WELL_SUPPORTED,
  ins_132701: FiTier.WELL_SUPPORTED,
  ins_132925: FiTier.WELL_SUPPORTED,
  ins_132941: FiTier.WELL_SUPPORTED,
  ins_132970: FiTier.WELL_SUPPORTED,
  ins_133215: FiTier.WELL_SUPPORTED,
  ins_133394: FiTier.WELL_SUPPORTED,
  ins_133396: FiTier.WELL_SUPPORTED,
  ins_133507: FiTier.WELL_SUPPORTED,
  ins_134593: FiTier.WELL_SUPPORTED,
  ins_135993: FiTier.WELL_SUPPORTED,
  ins_137007: FiTier.WELL_SUPPORTED,
  ins_25: FiTier.WELL_SUPPORTED,
  ins_26: FiTier.WELL_SUPPORTED,
  ins_27: FiTier.WELL_SUPPORTED,
  ins_29: FiTier.WELL_SUPPORTED,
  ins_3: FiTier.WELL_SUPPORTED,
  ins_32: FiTier.WELL_SUPPORTED,
  ins_4: FiTier.WELL_SUPPORTED,
  ins_56: FiTier.WELL_SUPPORTED,
  ins_110438: FiTier.LIMITED_SUPPORT,
  ins_113059: FiTier.LIMITED_SUPPORT,
  ins_113421: FiTier.LIMITED_SUPPORT,
  ins_115674: FiTier.LIMITED_SUPPORT,
  ins_116225: FiTier.LIMITED_SUPPORT,
  ins_116799: FiTier.LIMITED_SUPPORT,
  ins_120013: FiTier.LIMITED_SUPPORT,
  ins_127296: FiTier.LIMITED_SUPPORT,
  ins_14: FiTier.LIMITED_SUPPORT,
  ins_15: FiTier.LIMITED_SUPPORT,
  ins_20: FiTier.LIMITED_SUPPORT,
  ins_21: FiTier.LIMITED_SUPPORT,
  ins_5: FiTier.LIMITED_SUPPORT,
  ins_7: FiTier.LIMITED_SUPPORT,
}

/**
 * Classify a Plaid institution by its ID.
 * Returns WELL_SUPPORTED or LIMITED_SUPPORT from the static map.
 * Unknown Plaid-supported institutions default to LIMITED_SUPPORT per PRD.
 */
export function classifyInstitution(institutionId: string): FiTier {
  return FI_TIER_MAP[institutionId] ?? FiTier.LIMITED_SUPPORT
}

/**
 * Default suggestions shown before the user searches.
 * Ordered by Heard user frequency. Institution IDs sourced from production
 * financial_accounts data, cross-referenced with auto-recon health and
 * limited_bank_access_statuses.
 *
 * See CORE-6147 for planned quarterly refresh of this list.
 */
export const DEFAULT_SUGGESTIONS: PlaidInstitutionResult[] = [
  { institutionId: 'ins_56', name: 'Chase' },
  { institutionId: 'ins_127989', name: 'Bank of America' },
  { institutionId: 'ins_10', name: 'American Express' },
  { institutionId: 'ins_127991', name: 'Wells Fargo' },
  { institutionId: 'ins_128026', name: 'Capital One' },
  { institutionId: 'ins_127296', name: 'BlueVine' },
]
